module.exports = __webpack_public_path__ + "img/switzerland.1b37ff4d.svg";